import Vue from 'vue'
export default {
    // Vue.js的插件应当有一个公开方法 install。这个方法的第一个参数是 Vue 构造器，第二个参数是一个可选的选项对象。
    install: function (Vue) {
        Vue.prototype.global_getage = (param) => getAge(param)
    }
}

//获取年龄
function getAge (dob) {
    let birthdays = new Date(dob.replace(/-/g, "/"));
    let d = new Date();
    let age =
        d.getFullYear() -
        birthdays.getFullYear() -
        (d.getMonth() < birthdays.getMonth() ||
        (d.getMonth() == birthdays.getMonth() &&
        d.getDate() < birthdays.getDate())
        ? 1
        : 0);
    return age;
}


